import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { PageHeader } from "@/components/Bits";
import api from "@/lib/api";
import { ClipboardList } from "lucide-react";

export default function SurveysList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/surveys").then((r) => setItems(r.data)).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        <PageHeader overline="Field operations" title="Surveys" description="Booked, scheduled and completed site surveys." />
        {loading ? <div className="overline">Loading…</div> : items.length === 0 ? (
          <div className="bq-card p-10 text-center"><ClipboardList size={24} className="mx-auto text-[var(--bq-text-muted)]" /><div className="overline mt-3">No surveys</div></div>
        ) : (
          <div className="bq-card overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-[var(--bq-bg)]">
                <tr>
                  <th className="text-left px-6 py-3 overline">Date</th>
                  <th className="text-left px-6 py-3 overline">Project</th>
                  <th className="text-left px-6 py-3 overline">Surveyor</th>
                  <th className="text-left px-6 py-3 overline">Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.map((s) => (
                  <tr key={s.id} className="border-t border-[var(--bq-border)] hover:bg-[var(--bq-bg)]" data-testid={`survey-row-${s.id}`}>
                    <td className="px-6 py-4">{new Date(s.requested_date).toLocaleDateString("en-ZA")}</td>
                    <td className="px-6 py-4">{s.project_id.slice(0, 8)}</td>
                    <td className="px-6 py-4">{s.surveyor_name || "—"}</td>
                    <td className="px-6 py-4"><span className={`pill ${s.status === "completed" ? "pill-approved" : s.status === "scheduled" ? "pill-progress" : "pill-quote"}`}>{s.status}</span></td>
                    <td className="px-6 py-4 text-right">
                      <Link to={`/projects/${s.project_id}`} className="text-[var(--bq-orange)] font-semibold text-sm" data-testid={`open-survey-${s.id}`}>Open project →</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
